export const NotFound = () => {
    return (<>NotFound</>);
}